<template>
  <div>
    <lottie-animation
      :width="width"
      path="storage/images/animations/loader.json"
    />
  </div>
</template>

<style scoped>
</style>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
  props: {
    width: {
      type: Number,
      required: false,
      default: 50,
    },
  },
  components: {
    LottieAnimation,
  },
};
</script>
